
    // @ts-ignore
    module.exports = __webpack_public_path__ + "webaudiorecorder.worklet.js";
    